import Vue from "vue";
import { ir } from "./check_domain_ir";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";

// import {VERIFY_AUTH} from "@/core/services/store/auth.module";
import "material-design-icons/iconfont/material-icons.css";
import mixins from "./mixin";

// Global 3rd party plugins
import "vue-toastification/dist/index.css";
import PerfectScrollbar from "perfect-scrollbar";
import Echo from "laravel-echo";

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";

import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Toast from "vue-toastification";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

//custom
import "./custom";
import { mapGetters } from "vuex";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
import CustomPopup from "./core/plugins/TitleRibbon/plugins/popup/customPopup";
import CustomTabs from "./core/plugins/TitleRibbon/plugins/customTabs/index";
import VueTable from "./core/plugins/TitleRibbon/plugins/vueTable";
import {
  destroyToken,
  getToken,
  saveToken,
} from "./core/plugins/TitleRibbon/assets/js/jwt.service";
import axiosApi from "axios";
Vue.use(VueTelInput);

Vue.config.productionTip = false;

let timer = null;
export const debounce = function (fn, delay) {
  clearTimeout(timer);

  timer = setTimeout(fn, delay);
};
Vue.prototype.$ai_terminalads = ir("ai-api.terminalads.com");
Vue.prototype.$ai_terminal = ir("https://ai-api.terminalads.com");
Vue.prototype.$AiApiUrl = ir(process.env.VUE_APP_URL_AI);
Vue.prototype.$AppUrl = ir(process.env.VUE_APP_URL);
Vue.prototype.$AppRoot = ir(process.env.VUE_APP_ROOT);
Vue.prototype.$VcfUrl = ir(process.env.VUE_APP_VCF);
Vue.prototype.$robotApp = ir(process.env.VUE_APP_ROBOT);
Vue.prototype.$RbApp = ir(process.env.VUE_APP_RB);
Vue.prototype.$CRAWLERApp = ir(process.env.VUE_APP_CRAWLER);
Vue.prototype.$ApiUrlApp = ir(process.env.VUE_APP_API_URL);
Vue.prototype.$hostApp = ir(process.env.VUE_APP_WS_HOST);
Vue.prototype.$smsUrl = ir("https://core-sms.terminalads.com");
Vue.prototype.$transportUrl = ir("https://core-transport.terminalads.com");
Vue.prototype.$billboardUrl = ir("https://core-billboard.terminalads.com");
Vue.prototype.$showUrl = ir("https://core-show.terminalads.com");
Vue.prototype.$digiUrl = ir("https://core-digi.terminalads.com");
Vue.prototype.$mediaUrl = ir("https://core-media.terminalads.com");
Vue.prototype.$meliUrl = ir("https://core-meli.terminalads.com");
Vue.prototype.$robotUrl = ir("https://core-robot.terminalads.com");
Vue.prototype.$infoUrl = ir("https://core-info.terminalads.com");
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com");
Vue.prototype.$sarveLand = ir("https://api.terminalads.com");
Vue.prototype.$paymak_land = ir("https://sms-api.terminalads.com");
Vue.prototype.$terminalApi = ir("api.terminalads.com");
Vue.prototype.$terminal = ir(".terminalads.com");
Vue.prototype.$coreApi3 = ir("https://api.terminalads.com");
Vue.prototype.$coreApi2 = ir("https://api.terminalads.com/api");
Vue.prototype.$coreApi = ir("https://core.terminalads.com");
Vue.prototype.$qrApi = ir("https://qr-api.terminalads.com/api");
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$robotApi = ir("https://robot-api.terminalads.com/api");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$corepayamakApi = ir("https://core-sms.terminalads.com");
Vue.prototype.$terminalads = ir("https://terminalads.com");
Vue.prototype.$coreqrOrigin = ir("core-qr.terminalads.com");
Vue.prototype.$robotCoreApi = ir("https://core-robot.terminalads.com");
Vue.prototype.$coreqrApi = ir("https://core-qr.terminalads.com");
Vue.prototype.$digiApi = ir("https://core-digi.terminalads.com");
Vue.prototype.$appUrl =
  ir(process.env.VUE_APP_URL) || ir("https://qr-api.terminalads.com/api");
Vue.prototype.$coreterminalUrl = ir("core.terminalads.com");
Vue.prototype.$roboatUrl = ir("https://robot-api.terminalads.com");
Vue.prototype.$rootUrl = ir(process.env.VUE_APP_ROOT);
Vue.prototype.$aiApi = ir("https://ai-api.terminalads.com/api");
Vue.prototype.$qrUrl = ir("https://qr-api.terminalads.com");
Vue.prototype.$corePanelUrl = ir("https://core_panel.terminalads.com");
Vue.prototype.$cdnUrl = ir("https://cdn.terminalads.com");
Vue.prototype.$CRAWLER = ir(process.env.VUE_APP_CRAWLER);
Vue.prototype.$services = {
  1: ir("https://core.terminalads.com"),
  2: ir("https://core-sms.terminalads.com"),
  3: ir("https://core-qr.terminalads.com"),
  4: ir("https://core-robot.terminalads.com"),
  5: ir("https://core-billboard.terminalads.com"),
  10: ir("https://core-info.terminalads.com"),
  11: ir("https://core-file.terminalads.com"),
  13: ir("https://core-digi.terminalads.com"),
  14: ir("https://core-graphic.terminalads.com"),
  19: ir("https://core-ai.terminalads.com"),
};

window.PerfectScrollbar = PerfectScrollbar;
window.url = Vue.prototype.$AppUrl;

let id_token = localStorage.getItem("id_token");
const axios = axiosApi.create({
  baseURL: process.env.VUE_APP_URL_AI,
  timeout: 50000,
  headers: {
    Authorization: !!id_token ? "Bearer " + id_token : undefined,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

Vue.prototype.$api = axios;

window.Pusher = require("pusher-js");
try {
  const echo = new Echo({
    wsHost: Vue.prototype.$ai_terminalads,
    broadcaster: "pusher",
    key: "local",
    cluster: "mt1",
    forceTLS: true,
    authEndpoint: Vue.prototype.$aiApi + "/broadcast/auth",
    wsPort: 6002,
    // wsHost: "195.110.38.200",
    //wsHost: "robot-api.terminalads.com",
    auth: {
      headers: {
        Authorization: !!id_token ? "Bearer " + id_token : undefined,
      },
    },
  });
  Vue.prototype.$echo = echo;
  console.log("echo: ", echo);
} catch (e) {
  console.error("echo: ", e);
}

export const rbland = axiosApi.create({
  baseURL: process.env.VUE_APP_RB,
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const rbAxios = axiosApi.create({
  baseURL: Vue.prototype.$robotApp,
  timeout: 15000,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const RobotAxios = axiosApi.create({
  baseURL: process.env.VUE_APP_CRAWLER,
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const SmsAxios = axiosApi.create({
  baseURL: Vue.prototype.$payamakApi2,
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

Vue.use(mixins);

Vue.component("customPopup", CustomPopup);
Vue.component("customTabs", CustomTabs);
Vue.component("vueTable", VueTable);

let dashboardConfig = {
  announcement: {
    img:
      Vue.prototype.$robotCoreApi +
      "/advertisement-billboard-6097659-5013090.png", // url
    text: "QR ثبت شده", // any
    url: router.resolve({ name: "send.sms.divar" }).href, // page to go
  },
  numbers: {
    img:
      Vue.prototype.$robotUrl + "/advertisement-billboard-6097659-5013090.png", // require from local assets
    text: "شماره ها",
    url: router.resolve({ name: "divar.report" }).href,
  },
  counter: new Promise((resolve) => {
    resolve({
      announcement: 0,
      numbers: 0,
    });
  }),
};
let static_top_menu = [];
const img = require("/public/media/img/logo.png");
Vue.use(TerminalTitleRibbon, {
  store,
  // an inctance of axios *reqire*
  axios,
  // global configs for layout & dashboard
  config: () => ({
    // dashboard data
    dashboardConfig,
    // links in top of menu
    static_top_menu,
    // set a getter in config.getters store
    header_logo: img,
  }),
  headers: {
    // send Authorization with Bearer anytime.
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  // this plugin need user permission for check user access.
  permissions: () => store.state.ability,
  core_url: Vue.prototype.$sarveLand,
  front_url: Vue.prototype.$coreApi,
  // send ID for each project
  sid: 19,
});

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
  maxToasts: 1,
  newestOnTop: true,
  color: "black",
});

Vue.use(VuePersianDatetimePicker, {
  name: "date-picker",
  props: {
    autoSubmit: true,
    clearable: true,
    format: "YYYY-MM-DD HH:mm:ss",
    displayFormat: "jYYYY-jMM-jDD HH:mm:ss",
  },
});

$("input[name='table-search']")
  .parent()
  .removeClass("offset-md-6")
  .addClass("ms-auto");

export const Bus = new Vue({
  methods: {
    setProp(name, value) {
      this[name] = value;
    },
    getProp(name) {
      return this[name];
    },
  },
});

Vue.mixin({
  methods: {
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    persian(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      return str1;
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    // TODO: delete lines
  },
});

window.Vue = new Vue({
  data() {
    return {
      gotToken: false,
    };
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),

  methods: {
    async fetch() {
      let result = null;
      if (window.location.href.includes("assistantchat")) {
        return null;
      }

      if (!getToken()) {
        const { origin, hash } = window.location;

        destroyToken(origin, hash.substring(1));
      } else {
        await $.ajax({
          // url: Vue.prototype.$AppUrl + "/abilitiesType",
          url: "https://core-qr.terminalads.com/api/user/abilities",
          async: false,
          fn: this.fetch,
          headers: {
            Authorization: getToken(),
            ACCEPT: "application/json",
          },
          success: (data) => {
            this.permissions();
            this.gotToken = true;
            this.$store.dispatch("global/isLoaded", true);
            this.$store.state.ability = data.data;
            store.commit("setAbilities", data.data);
            result = data.data;
          },
        });
      }

      return result;
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf("?");
      const end = url.indexOf("#");
      url = url.substring(start, end);
      let token = url.split("token=")[1];
      if (token) {
        saveToken(token);
        return window.history.pushState(
          "dashboard",
          "Title",
          "/" + window.location.hash,
        );
      }
    },
    permissions() {
      Vue.directive("status", (element, binding) => {
        const value = binding.value;
        const abilities = this.$store.state.ability;

        if (
          abilities.indexOf(value + ":active") < 0 &&
          abilities.indexOf(value + ":show") < 0
        ) {
          $(element).remove();
          return;
        }
        if (abilities.indexOf(value + ":show") > -1) {
          $(element).attr("disabled", true);
        }
      });
    },
  },
  async beforeMount() {
    this.setToken();

    router.beforeResolve(async (to, from, next) => {
      window.Vue.$store.getters["global/isLoaded"] || (await this.fetch());
      if (to.meta.permission && !this.ribbon_can(to.meta.permission))
        next({ name: "dashboard" });
      else next();
    });
  },
}).$mount("#app");
